import { Layout } from 'antd'
import React from 'react'
import DotsBg from 'assets/images/dots-bg.svg?react'

const PublicLayout = ({ children }) => {
  return (
    <Layout>
      <Layout.Content style={{ backgroundColor: '#FAFAFA' }}>
        <DotsBg style={{ position: 'absolute', inset: 0, height: '100vh', width: '100vw' }} />
        <div
          style={{
            zIndex: 1,
            position: 'relative',
            minHeight: '100vh',
            minWidth: '100vw',
          }}
        >
          {children}
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default PublicLayout
